import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { localizationSelectors } from '@lifesize/nucleus';
import { changeLocale } from 'actions/I18n';
import SelectLocale from 'components/SelectLocale/SelectLocale';

const mapDispatchToProps = (dispatch) => ({
  changeLocale: (locale) => {
    dispatch(changeLocale(locale, true, true));
  }
});

const mapStateToProps = (state) => {
  const { languageId, languageOptions } = localizationSelectors.localization(state);

  return {
    languageId,
    languageOptions
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SelectLocale));
